export default
{
  next: ['Próximo encontro', 'Next meeting', 'Siguiente encuentro'],
  time: ['Horário:', 'Time:', 'Horario:'],
  place: ['Local:', 'Place:', 'Local:'],
  notSche: ['Ainda não foi marcado um novo encontro', 'A meeting was not yet been schedule', 'Todavía no se ha marcado un nuevo encuentro'],
  title: ['Agenda', 'Schedule', 'Programa']

}



// WEBPACK FOOTER //
// ./src/constants/Agenda.js